import { Component, EventEmitter, AfterViewInit, OnInit, Output,ElementRef, ViewChildren, Input, DoCheck, AfterContentInit, AfterContentChecked, AfterViewChecked } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MaterializeAction } from 'angular2-materialize';
import { UserService } from './user.service';
import { GlobalErrorHandler } from '../shared/core/error-handler';
import { NotificationsService, Notification } from '../shared/helper-components/index';

@Component({
  selector: 'user-menu',
  template: require('./user-menu.component.html'),
})
export class UserMenuComponent implements OnInit, DoCheck {
  modalActions = new EventEmitter<string | MaterializeAction>();
  userAction: string = "Resend";
  menuForm : FormGroup;
  @Input() userEmail: string;
  @Input() clientX;
  @Input() clientY;
  @Input() userStatus: string;
  resendVisible: boolean = true;
  extendVisible: boolean = true;

  constructor(
    private fb: FormBuilder,
    private _userService: UserService,
    private _errorHandler: GlobalErrorHandler,
    private _notificationsService: NotificationsService,
  ){
    
  }

  ngDoCheck(): void {
    var divModal: any = document.querySelector("#modal-user-menu");
    var style = window.getComputedStyle(divModal);
    var height = "80px";
    if (this.userStatus=="Registered" || this.userStatus=="Pending"){
      this.resendVisible=true;
      this.extendVisible=false;
      height = "45px";
    }
    if (this.userStatus=="Inactive"){
      this.resendVisible=false;
      this.extendVisible=true;
      height = "45px";
    }
    

    if (style.display=="block"){
      divModal.style.cssText = `z-index: 1200; opacity: 1; transform: scaleX(1); display: block; width: 200px; height: ${height}; overflow-y: hidden; min-height: unset; min-width: unset; position: absolute; top: ${this.clientY}; left: ${this.clientX};`;
    }
  }
 
  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    if (!this.menuForm){
      this.menuForm = this.fb.group({
        userAction: '',
      });
    }
    this.userAction = "Resend";
  }

  closeMenu(): void {
    $('#modal-user-menu').modal('close');
  }

  changeOptionUserMenu(action: string){
    this.userAction = action;
  }

  resend(){
    this._userService.resendUser(this.userEmail)
    .subscribe( (success: any) => {
      if (!success){
        this._notificationsService.add(new Notification('error', `Something went wrong trying to resend email notification`));
      }
      else{
        this._notificationsService.add(new Notification('success', `User ${this.userEmail} will receive a new email notification`));
      }
    },
    (error: any)=>{
      this._errorHandler.processError(error);
    });
    $('#modal-user-menu').modal('close');
  }

  extend(){
    this._userService.extendUser(this.userEmail)
    .subscribe( (success: any) => {
      if (!success){
        this._notificationsService.add(new Notification('error', `Something went wrong trying to extend user validity`));
      }
      else{
        this._notificationsService.add(new Notification('success', `User validity of ${this.userEmail} will be extended`));
      }
    },
    (error: any)=>{
      this._errorHandler.processError(error);
    });
    $('#modal-user-menu').modal('close');
  }

  

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/users/user-menu.component.ts